export type IPlugin = string;

export type IPluginsConfig = Set<IPlugin>;

export type IPlugins = IPluginsConfig;
